export default __webpack_public_path__ + "static/media/Group 2015.5591f263.svg";